import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { connectState, InputObservable } from '@examdojo/angular/util';
import { IconComponent } from '@examdojo/core/icon';
import { UntilDestroy } from '@ngneat/until-destroy';
import { combineLatest, map, Observable } from 'rxjs';
import { AssetTreeNode } from '../../model/asset-tree-node.model';

@UntilDestroy()
@Component({
  selector: 'exam-asset-tree-dnd-tooltip',
  templateUrl: './asset-tree-dnd-tooltip.component.html',
  styleUrls: ['./asset-tree-dnd-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class AssetTreeDndTooltipComponent {
  @Input()
  @InputObservable()
  nodes: AssetTreeNode[] = [];
  private readonly nodes$!: Observable<AssetTreeNode[]>;

  @Input()
  @InputObservable()
  allowedToBeMoved?: boolean;
  private readonly allowedToBeMoved$!: Observable<boolean>;

  readonly state = connectState({
    notAllowedReason: this.allowedToBeMoved$.pipe(
      map((allowedToBeMoved): NotAllowedReason | undefined => {
        if (!allowedToBeMoved) {
          return NotAllowedReason.NotAllowedToBeMoved;
        }
        return;
      }),
    ),
    nodes: combineLatest([this.nodes$, this.allowedToBeMoved$]).pipe(
      map(([nodes, allowedToBeMoved]) => {
        if (allowedToBeMoved) {
          return nodes;
        }
        return [];
      }),
    ),
  });

  readonly NotAllowedReason = NotAllowedReason;
}

enum NotAllowedReason {
  NotAllowedToBeMoved = 'notAllowedToBeMoved',
}
